import { render, staticRenderFns } from "./botao-voltar.vue?vue&type=template&id=6b9a420e&scoped=true"
import script from "./botao-voltar.vue?vue&type=script&lang=js"
export * from "./botao-voltar.vue?vue&type=script&lang=js"
import style0 from "./botao-voltar.vue?vue&type=style&index=0&id=6b9a420e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a420e",
  null
  
)

export default component.exports